import React from "react";
import PropTypes from "prop-types";
import { darkDenium } from "../../constants/colors";
import { getSvgFilter } from "./DashboardUtils";
import { ReactComponent as BiosimilarsIcon } from "../../assets/Biosimilars.svg";
import { ReactComponent as CoPayAssistIcon } from "../../assets/CoPayAssist.svg";
import { ReactComponent as ECMPIcon } from "../../assets/ECMP.svg";
import { ReactComponent as GLP1Icon } from "../../assets/GLP 1.svg";
import { ReactComponent as IntSourcingIcon } from "../../assets/IntSourcing.svg";
import { ReactComponent as PAPIcon } from "../../assets/PAP.svg";
import { ReactComponent as Womenshealth } from "../../assets/WomensHealth.svg";
import { ReactComponent as DiabetesIcon } from "../../assets/Diabetes.svg";
import { ReactComponent as WeightManagementIcon } from "../../assets/WeightManagement.svg";

const ProgramIcon = ({
  name: programName,
  customStyle = null,
  iconColor = darkDenium,
}) => {
  const iconStyle = {
    width: "16px",
    height: "16px",
    marginRight: "4px",
    filter: getSvgFilter(iconColor),
    ...customStyle,
  };

  const icons = {
    Biosimilars: <BiosimilarsIcon style={iconStyle} />,
    "Copay Assist": <CoPayAssistIcon style={iconStyle} />,
    ECMP: <ECMPIcon style={iconStyle} />,
    "GLP-1": <GLP1Icon style={iconStyle} />,
    "International Sourcing": <IntSourcingIcon style={iconStyle} />,
    PAP: <PAPIcon style={iconStyle} />,
    "Women's Health Program": <Womenshealth style={iconStyle} />,
    Diabetes: <DiabetesIcon style={iconStyle} />,
    "Weight Management": <WeightManagementIcon style={iconStyle} />,
    Weight: <WeightManagementIcon style={iconStyle} />,
  };

  const nameValue =
    typeof programName === "string" ? programName : programName?.name || "";
  const name = nameValue.trim().toLowerCase();

  if (!name) return null;

  const matchedKey = Object.keys(icons).find((key) => {
    const k = key.toLowerCase();
    return k === name || k.includes(name) || name.includes(k);
  });

  return icons[matchedKey] || null;
};

ProgramIcon.propTypes = {
  name: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      name: PropTypes.string,
    }),
  ]).isRequired,
  customStyle: PropTypes.object,
  iconColor: PropTypes.string,
};

export default ProgramIcon;
